export const QUIZ_QUESTION_CORRECT_ANSWER_DELAY_SECONDS = 1.5;
export const QUIZ_QUESTION_CHANGE_ANSWER_LIMIT_SECONDS = 5;
export const QUIZ_QUESTION_CHANGE_ANSWER_LIMIT_LABEL = `${QUIZ_QUESTION_CHANGE_ANSWER_LIMIT_SECONDS} seconds`;
export const EXTRA_ENTRIES_PER_SMS_ACCEPTANCE = 2;
